module.exports = __webpack_public_path__ + "img/COMBO SPIRAL BW.c22d214.svg";